module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/sucursales/sucursales.component.scss
// module id = ./src/app/administracion/sucursales/sucursales.component.scss
// module chunks = main